/** Structural equality over JSON-shaped values. Keys whose value is undefined
 *  are ignored, so { a: 1, b: undefined } equals { a: 1 }. */
export function deepEqual(a, b) {
    if (a === b)
        return true;
    if (typeof a !== typeof b)
        return false;
    if (a === null || b === null || typeof a !== 'object')
        return false;
    if (Array.isArray(a) || Array.isArray(b)) {
        if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length)
            return false;
        return a.every((item, index) => deepEqual(item, b[index]));
    }
    const left = a;
    const right = b;
    const leftKeys = Object.keys(left).filter((key) => left[key] !== undefined);
    const rightKeys = Object.keys(right).filter((key) => right[key] !== undefined);
    if (leftKeys.length !== rightKeys.length)
        return false;
    return leftKeys.every((key) => key in right && deepEqual(left[key], right[key]));
}
//# sourceMappingURL=equal.js.map